import { render, staticRenderFns } from "./Brainstorm.vue?vue&type=template&id=71f13c2e&scoped=true"
import script from "./Brainstorm.vue?vue&type=script&lang=ts"
export * from "./Brainstorm.vue?vue&type=script&lang=ts"
import style0 from "./Brainstorm.vue?vue&type=style&index=0&id=71f13c2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f13c2e",
  null
  
)

export default component.exports